export const getVisibleSpecialties = (
  specialties: string[],
  ref: { current: HTMLElement | null },
  viewType: 'grid' | 'carousel' = 'carousel'
) => {
  const container = ref.current

  if (!container || specialties.length === 0) {
    return { visible: specialties, remainingCount: 0 }
  }

  const temp = document.createElement('div')
  temp.className = `care-team-${viewType}__specialty`
  temp.style.visibility = 'hidden'
  temp.style.position = 'absolute'
  temp.textContent = specialties[0]

  container.appendChild(temp)

  const style = getComputedStyle(temp)

  const badgeWidth =
    temp.offsetWidth +
    parseFloat(style.marginLeft) +
    parseFloat(style.marginRight)

  const badgeHeight =
    temp.offsetHeight +
    parseFloat(style.marginTop) +
    parseFloat(style.marginBottom)

  container.removeChild(temp)

  const containerWidth = container.offsetWidth
  const containerHeight = container.offsetHeight

  const maxPerRow = Math.max(1, Math.floor(containerWidth / badgeWidth))
  const maxRows = Math.max(1, Math.floor(containerHeight / badgeHeight))
  const maxVisible = maxPerRow * maxRows
  const visible = specialties.slice(0, maxVisible)
  const remainingCount = Math.max(0, specialties.length - maxVisible)

  return { visible, remainingCount }
}
